<template>
  <h4>
    {{ book.title }}
    <small class="text-muted d-block"> {{ book.subTitle }} </small>
  </h4>
</template>
<script>
export default {
  props: ["book"]
};
</script>
<style lang="scss" scoped>
h4 {
  hyphens: auto;
}
</style>
